(function () {
  var ACCEPTED_MIME = ["image/png", "image/jpeg", "image/svg+xml", "image/webp"];
  var MAX_FILE_BYTES = 5 * 1024 * 1024;
  var MIN_DIMENSION = 200;

  function $(root, selector) {
    return root.querySelector(selector);
  }

  function $all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function roundedRect(ctx, x, y, width, height, radius) {
    var r = Math.min(radius, width / 2, height / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + width, y, x + width, y + height, r);
    ctx.arcTo(x + width, y + height, x, y + height, r);
    ctx.arcTo(x, y + height, x, y, r);
    ctx.arcTo(x, y, x + width, y, r);
    ctx.closePath();
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var dataUrl = String(reader.result || "");
        if (file.type === "image/svg+xml") {
          resolve({ dataUrl: dataUrl, width: 9999, height: 9999 });
          return;
        }
        var img = new Image();
        img.onload = function () {
          resolve({ dataUrl: dataUrl, width: img.naturalWidth, height: img.naturalHeight });
        };
        img.onerror = function () {
          reject(new Error("Could not read image"));
        };
        img.src = dataUrl;
      };
      reader.onerror = function () {
        reject(new Error("Could not read file"));
      };
      reader.readAsDataURL(file);
    });
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (!/^data:/.test(src)) img.crossOrigin = "anonymous";
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(new Error("Could not load image"));
      };
      img.src = src;
    });
  }

  function imageToDataUrl(src) {
    return loadImage(src).then(function (img) {
      var width = img.naturalWidth || img.width || 800;
      var height = img.naturalHeight || img.height || 400;
      if (width < 2 || height < 2) {
        width = 800;
        height = 400;
      }
      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      return canvas.toDataURL("image/png");
    });
  }

  function rasterize(dataUrl) {
    return loadImage(dataUrl).then(function (img) {
      var width = img.naturalWidth || img.width || 800;
      var height = img.naturalHeight || img.height || 800;
      if (width < 2 || height < 2 || (width === 150 && height === 150)) {
        width = 800;
        height = 800;
      }
      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      return { pngDataUrl: canvas.toDataURL("image/png"), width: width, height: height };
    });
  }

  function toEngravingMask(dataUrl) {
    return rasterize(dataUrl).then(function (raster) {
      return loadImage(raster.pngDataUrl).then(function (img) {
        var canvas = document.createElement("canvas");
        canvas.width = raster.width;
        canvas.height = raster.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, raster.width, raster.height);
        var imageData = ctx.getImageData(0, 0, raster.width, raster.height);
        var data = imageData.data;
        for (var i = 0; i < data.length; i += 4) {
          var red = data[i];
          var green = data[i + 1];
          var blue = data[i + 2];
          var alpha = data[i + 3];
          if (alpha < 10) {
            data[i] = 0;
            data[i + 1] = 0;
            data[i + 2] = 0;
            data[i + 3] = 0;
            continue;
          }
          var lum = 0.299 * red + 0.587 * green + 0.114 * blue;
          if (alpha > 240 && lum > 235) {
            data[i] = 0;
            data[i + 1] = 0;
            data[i + 2] = 0;
            data[i + 3] = 0;
          } else {
            data[i] = 0;
            data[i + 1] = 0;
            data[i + 2] = 0;
            data[i + 3] = Math.round(255 * (1 - lum / 255) * (alpha / 255));
          }
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas.toDataURL("image/png");
      });
    });
  }

  function safeFilename(value) {
    return String(value || "Company")
      .replace(/[^a-zA-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .slice(0, 40) || "Company";
  }

  function downloadBlob(blob, filename) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  function init(root) {
    var canvas = $(root, "[data-hd-b2b-canvas]");
    var fallbackCtx = null;
    var threeViewer = null;
    if (window.HumanodoroB2BThree) {
      try {
        threeViewer = new window.HumanodoroB2BThree(canvas);
        canvas.classList.add("is-three");
      } catch (err) {
        console.warn("[humanodoro-b2b] WebGL viewer unavailable, using canvas fallback", err);
        threeViewer = null;
      }
    }
    var modal = $(root, "[data-hd-b2b-modal]");
    var uploadForm = $(root, "[data-hd-b2b-upload-form]");
    var contactForm = $(root, "[data-hd-b2b-contact-form]");
    var emailInput = $(root, "[data-hd-b2b-email]");
    var companyInput = $(root, "[data-hd-b2b-company]");
    var fileInput = $(root, "[data-hd-b2b-file]");
    var fileDrop = $(root, "[data-hd-b2b-drop]");
    var filePreview = $(root, "[data-hd-b2b-file-preview]");
    var fileName = $(root, "[data-hd-b2b-file-name]");
    var error = $(root, "[data-hd-b2b-error]");
    var idleActions = $(root, "[data-hd-b2b-idle-actions]");
    var submittedActions = $(root, "[data-hd-b2b-submitted-actions]");
    var previewing = $(root, "[data-hd-b2b-previewing]");
    var pdfButton = $(root, "[data-hd-b2b-pdf]");
    var quoteButton = $(root, "[data-hd-b2b-quote]");
    var resetButton = $(root, "[data-hd-b2b-reset]");
    var finalCta = $(root, "[data-hd-b2b-final-cta]");
    var logoRotationLabel = $(root, "[data-hd-b2b-rotation]");

    var state = {
      companyName: "",
      email: "",
      logoDataUrl: null,
      logoFileName: "",
      rawPreviewUrl: "",
      rawPreviewLabel: "",
      logoImage: null,
      hasUploadedFile: false,
      logoRotation: 0,
      padYaw: -0.12,
      zoom: 1,
      dragging: false,
      dragX: 0,
      dragYaw: 0
    };

    function setError(message) {
      if (!error) return;
      error.textContent = message || "";
      error.hidden = !message;
    }

    function setBusy(button, busy, label) {
      if (!button) return;
      button.disabled = Boolean(busy);
      if (label) button.textContent = label;
    }

    function updateFilePreview(src, name) {
      if (filePreview) {
        filePreview.src = src || "";
        filePreview.hidden = !src;
        filePreview.style.transform = "rotate(" + state.logoRotation + "deg)";
      }
      if (fileName) fileName.textContent = name || "PNG, JPG, SVG, or WebP · max 5 MB";
      if (logoRotationLabel) logoRotationLabel.textContent = state.logoRotation + "°";
    }

    function draw() {
      if (threeViewer) {
        threeViewer.render();
        return;
      }
      var ctx = fallbackCtx || canvas.getContext("2d");
      fallbackCtx = ctx;
      var rect = canvas.getBoundingClientRect();
      var dpr = Math.max(1, window.devicePixelRatio || 1);
      var width = Math.max(320, Math.round(rect.width * dpr));
      var height = Math.max(320, Math.round(rect.height * dpr));
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, rect.width, rect.height);

      var cx = rect.width / 2;
      var cy = rect.height / 2 + 6;
      var padWidth = Math.min(rect.width * 0.72, 420) * state.zoom;
      var padHeight = padWidth * 0.68;
      var depth = padHeight * 0.12;
      var skew = Math.sin(state.padYaw) * 36;

      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(state.padYaw * 0.18);
      ctx.scale(1, 0.72);

      ctx.save();
      ctx.translate(skew * 0.22, depth);
      roundedRect(ctx, -padWidth / 2, -padHeight / 2, padWidth, padHeight, 36);
      ctx.fillStyle = "#8f5f2f";
      ctx.fill();
      ctx.restore();

      var woodGradient = ctx.createLinearGradient(-padWidth / 2, -padHeight / 2, padWidth / 2, padHeight / 2);
      woodGradient.addColorStop(0, "#f6d493");
      woodGradient.addColorStop(0.45, "#d8a967");
      woodGradient.addColorStop(1, "#b87a3e");
      roundedRect(ctx, -padWidth / 2 + skew, -padHeight / 2, padWidth, padHeight, 36);
      ctx.fillStyle = woodGradient;
      ctx.fill();
      ctx.lineWidth = 6;
      ctx.strokeStyle = "#00111c";
      ctx.stroke();

      ctx.save();
      ctx.globalAlpha = 0.18;
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#7a4a22";
      for (var i = -6; i <= 6; i += 1) {
        ctx.beginPath();
        ctx.moveTo(-padWidth / 2 + 36 + skew, i * 22);
        ctx.bezierCurveTo(-padWidth / 5 + skew, i * 17 - 12, padWidth / 6 + skew, i * 17 + 12, padWidth / 2 - 36 + skew, i * 22 - 6);
        ctx.stroke();
      }
      ctx.restore();

      ctx.save();
      ctx.translate(skew, -6);
      roundedRect(ctx, -padWidth * 0.28, -padHeight * 0.22, padWidth * 0.56, padHeight * 0.44, 20);
      ctx.fillStyle = "rgba(255, 236, 191, .42)";
      ctx.fill();
      ctx.restore();

      if (state.logoImage) {
        ctx.save();
        ctx.translate(skew, -10);
        ctx.rotate((state.logoRotation * Math.PI) / 180);
        ctx.globalCompositeOperation = "multiply";
        ctx.globalAlpha = 0.72;
        var maxLogoW = padWidth * 0.36;
        var maxLogoH = padHeight * 0.28;
        var imgW = state.logoImage.naturalWidth || state.logoImage.width || 1;
        var imgH = state.logoImage.naturalHeight || state.logoImage.height || 1;
        var scale = Math.min(maxLogoW / imgW, maxLogoH / imgH);
        var drawW = imgW * scale;
        var drawH = imgH * scale;
        ctx.drawImage(state.logoImage, -drawW / 2, -drawH / 2, drawW, drawH);
        ctx.restore();
      }
      ctx.restore();
    }

    function render() {
      window.requestAnimationFrame(draw);
    }

    function openModal() {
      modal.hidden = false;
      setError("");
      window.setTimeout(function () {
        if (emailInput) emailInput.focus();
      }, 30);
    }

    function closeModal() {
      modal.hidden = true;
    }

    function sendLead() {
      if (!contactForm || !state.email) return Promise.resolve();
      var emailField = $(contactForm, "[name='contact[email]']");
      var nameField = $(contactForm, "[name='contact[name]']");
      var bodyField = $(contactForm, "[name='contact[body]']");
      if (emailField) emailField.value = state.email;
      if (nameField) nameField.value = state.companyName;
      if (bodyField) {
        bodyField.value = [
          "B2B preview lead",
          "Company: " + state.companyName,
          "Email: " + state.email,
          "Logo file: " + state.logoFileName
        ].join("\n");
      }
      return window.fetch((contactForm.getAttribute("action") || "/contact").split("#")[0], {
        method: "POST",
        body: new FormData(contactForm),
        credentials: "same-origin",
        headers: { Accept: "text/html" }
      }).catch(function (err) {
        console.warn("[humanodoro-b2b] lead capture failed", err);
      });
    }

    function updateSubmissionUI() {
      if (idleActions) idleActions.hidden = Boolean(state.email);
      if (submittedActions) submittedActions.hidden = !state.email;
      if (previewing) {
        previewing.hidden = !state.email;
        previewing.textContent = state.email ? "Previewing " + state.companyName : "";
      }
      if (finalCta) {
        finalCta.innerHTML = state.email ? "Get a quote <span aria-hidden=\"true\">→</span>" : "Upload your logo <span aria-hidden=\"true\">→</span>";
      }
    }

    function setLogo(maskDataUrl, fileName) {
      return loadImage(maskDataUrl).then(function (img) {
        state.logoDataUrl = maskDataUrl;
        state.logoImage = img;
        state.logoFileName = fileName || "";
        if (threeViewer) {
          threeViewer.setLogo(maskDataUrl, state.logoRotation, img.naturalWidth || img.width, img.naturalHeight || img.height);
        }
        render();
      });
    }

    function handleFile(file) {
      setError("");
      if (ACCEPTED_MIME.indexOf(file.type) === -1) {
        setError("Please upload a PNG, JPG, SVG, or WebP file.");
        return Promise.resolve(false);
      }
      if (file.size > MAX_FILE_BYTES) {
        setError("File too large. Please upload a file under 5 MB.");
        return Promise.resolve(false);
      }
      return readFileAsDataUrl(file)
        .then(function (result) {
          if (result.width < MIN_DIMENSION || result.height < MIN_DIMENSION) {
            setError("Image too small (" + result.width + "x" + result.height + "). Please use at least 200x200px.");
            return false;
          }
          updateFilePreview(result.dataUrl, file.name + " · click to replace");
          state.rawPreviewUrl = result.dataUrl;
          state.rawPreviewLabel = file.name + " · click to replace";
          state.logoDataUrl = result.dataUrl;
          state.logoFileName = file.name;
          state.hasUploadedFile = true;
          return toEngravingMask(result.dataUrl).then(function (mask) {
            return setLogo(mask, file.name).then(function () {
              return true;
            });
          });
        })
        .catch(function () {
          setError("Could not read the file. Try a different image.");
          return false;
        });
    }

    function selectExample(button) {
      $all(root, "[data-hd-b2b-example]").forEach(function (item) {
        item.classList.toggle("is-active", item === button);
      });
      var logoUrl = button.getAttribute("data-logo-url");
      var label = button.getAttribute("data-label") || "Example logo";
      imageToDataUrl(logoUrl)
        .then(toEngravingMask)
        .then(function (mask) {
          state.hasUploadedFile = false;
          return setLogo(mask, label);
        })
        .catch(function () {
          setError("Could not load this example logo.");
        });
    }

    function requestQuote() {
      if (!state.email) return openModal();
      var subject = encodeURIComponent("B2B pad quote - " + state.companyName);
      var body = encodeURIComponent(
        "Hi Humanodoro team,\n\nWe'd like a quote for branded pads.\n\nCompany: " +
          state.companyName +
          "\nEmail: " +
          state.email +
          "\n\nThanks!"
      );
      window.location.href = "mailto:info@humanodoro.com?subject=" + subject + "&body=" + body;
    }

    function generatePdf() {
      if (!state.email || !window.PDFLib) return;
      setBusy(pdfButton, true, "Generating...");
      var PDFDocument = window.PDFLib.PDFDocument;
      var StandardFonts = window.PDFLib.StandardFonts;
      var rgb = window.PDFLib.rgb;
      PDFDocument.create()
        .then(function (pdfDoc) {
          var page = pdfDoc.addPage([842, 595]);
          var width = page.getWidth();
          var height = page.getHeight();
          return Promise.all([
            pdfDoc.embedFont(StandardFonts.HelveticaBold),
            pdfDoc.embedFont(StandardFonts.Helvetica),
            fetch(canvas.toDataURL("image/png", 1)).then(function (r) { return r.arrayBuffer(); })
          ]).then(function (parts) {
            var fontBold = parts[0];
            var fontRegular = parts[1];
            return pdfDoc.embedPng(parts[2]).then(function (previewImage) {
              page.drawRectangle({ x: 0, y: 0, width: width, height: height, color: rgb(0.012, 0, 0.141) });
              var title = "Your Humanodoro Pad";
              var titleSize = 38;
              page.drawText(title, {
                x: (width - fontBold.widthOfTextAtSize(title, titleSize)) / 2,
                y: height - 78,
                size: titleSize,
                font: fontBold,
                color: rgb(1, 1, 1)
              });
              var subtitle = "Custom branded focus pads for " + state.companyName;
              var subtitleSize = 14;
              page.drawText(subtitle, {
                x: (width - fontRegular.widthOfTextAtSize(subtitle, subtitleSize)) / 2,
                y: height - 108,
                size: subtitleSize,
                font: fontRegular,
                color: rgb(0.72, 0.72, 0.75)
              });
              var imgAspect = previewImage.width / previewImage.height;
              var maxW = width - 120;
              var maxH = height - 190;
              var imgW = maxW;
              var imgH = imgW / imgAspect;
              if (imgH > maxH) {
                imgH = maxH;
                imgW = imgH * imgAspect;
              }
              page.drawImage(previewImage, {
                x: (width - imgW) / 2,
                y: 78 + (maxH - imgH) / 2,
                width: imgW,
                height: imgH
              });
              var contact = "humanodoro.com  |  info@humanodoro.com";
              page.drawText(contact, {
                x: (width - fontRegular.widthOfTextAtSize(contact, 11)) / 2,
                y: 32,
                size: 11,
                font: fontRegular,
                color: rgb(0.72, 0.72, 0.75)
              });
              return pdfDoc.save();
            });
          });
        })
        .then(function (bytes) {
          downloadBlob(new Blob([bytes], { type: "application/pdf" }), "Humanodoro_B2B_" + safeFilename(state.companyName) + ".pdf");
        })
        .catch(function (err) {
          console.error("[humanodoro-b2b] PDF generation failed", err);
          setError("PDF generation failed. Please try again.");
        })
        .finally(function () {
          setBusy(pdfButton, false, "Download PDF");
        });
    }

    $all(root, "[data-hd-b2b-open]").forEach(function (button) {
      button.addEventListener("click", openModal);
    });
    $all(root, "[data-hd-b2b-close]").forEach(function (button) {
      button.addEventListener("click", closeModal);
    });
    $all(root, "[data-hd-b2b-example]").forEach(function (button) {
      button.addEventListener("click", function () {
        selectExample(button);
      });
    });
    $all(root, "[data-hd-b2b-rotate-left]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        state.logoRotation = (state.logoRotation - 90 + 360) % 360;
        updateFilePreview(state.rawPreviewUrl, state.rawPreviewLabel);
        if (threeViewer) threeViewer.setLogoRotation(state.logoRotation);
        render();
      });
    });
    $all(root, "[data-hd-b2b-rotate-right]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        state.logoRotation = (state.logoRotation + 90) % 360;
        updateFilePreview(state.rawPreviewUrl, state.rawPreviewLabel);
        if (threeViewer) threeViewer.setLogoRotation(state.logoRotation);
        render();
      });
    });

    if (fileDrop) {
      fileDrop.addEventListener("click", function () {
        fileInput.click();
      });
      fileDrop.addEventListener("dragover", function (event) {
        event.preventDefault();
        fileDrop.classList.add("is-dragging");
      });
      fileDrop.addEventListener("dragleave", function () {
        fileDrop.classList.remove("is-dragging");
      });
      fileDrop.addEventListener("drop", function (event) {
        event.preventDefault();
        fileDrop.classList.remove("is-dragging");
        var file = event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) handleFile(file);
      });
    }
    if (fileInput) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        if (file) handleFile(file);
      });
    }
    if (uploadForm) {
      uploadForm.addEventListener("submit", function (event) {
        event.preventDefault();
        setError("");
        var email = String(emailInput.value || "").trim().toLowerCase();
        var company = String(companyInput.value || "").trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setError("Please enter a valid email address.");
          return;
        }
        if (!company) {
          setError("Please enter your company name.");
          return;
        }
        if (!state.logoDataUrl || !state.hasUploadedFile) {
          setError("Please upload your logo.");
          return;
        }
        state.email = email;
        state.companyName = company;
        sendLead();
        updateSubmissionUI();
        closeModal();
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    if (quoteButton) quoteButton.addEventListener("click", requestQuote);
    if (finalCta) {
      finalCta.addEventListener("click", function () {
        if (state.email) requestQuote();
        else openModal();
      });
    }
    if (pdfButton) pdfButton.addEventListener("click", generatePdf);
    if (resetButton) {
      resetButton.addEventListener("click", function () {
        state.email = "";
        state.companyName = "";
        state.logoDataUrl = null;
        state.logoImage = null;
        state.logoFileName = "";
        state.hasUploadedFile = false;
        state.logoRotation = 0;
        state.rawPreviewUrl = "";
        state.rawPreviewLabel = "";
        updateFilePreview("", "");
        if (uploadForm) uploadForm.reset();
        $all(root, "[data-hd-b2b-example]").forEach(function (item) { item.classList.remove("is-active"); });
        if (threeViewer) threeViewer.clearLogo();
        updateSubmissionUI();
        render();
      });
    }

    if (!threeViewer) {
      canvas.addEventListener("pointerdown", function (event) {
        state.dragging = true;
        state.dragX = event.clientX;
        state.dragYaw = state.padYaw;
        canvas.setPointerCapture(event.pointerId);
      });
      canvas.addEventListener("pointermove", function (event) {
        if (!state.dragging) return;
        state.padYaw = clamp(state.dragYaw + (event.clientX - state.dragX) / 420, -0.75, 0.75);
        render();
      });
      canvas.addEventListener("pointerup", function (event) {
        state.dragging = false;
        if (canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId);
      });
      canvas.addEventListener("wheel", function (event) {
        event.preventDefault();
        state.zoom = clamp(state.zoom + (event.deltaY < 0 ? 0.06 : -0.06), 0.82, 1.18);
        render();
      }, { passive: false });
    }

    window.addEventListener("resize", render);
    updateSubmissionUI();
    render();
  }

  document.addEventListener("DOMContentLoaded", function () {
    $all(document, "[data-hd-b2b-preview]").forEach(init);
  });
})();
